import React, { useState } from 'react';

const emptyRow = { vaults_from: '', vaults_to: '', share_pct: '' };

const RevShareTierTable = ({ tiers, onSave, onDelete, onAdd, saving }) => {
  const [editingId, setEditingId] = useState(null);
  const [editValues, setEditValues] = useState({});
  const [newRow, setNewRow] = useState(emptyRow);
  const [addingNew, setAddingNew] = useState(false);

  const startEdit = (tier) => {
    setEditingId(tier.id);
    setEditValues({ vaults_from: tier.vaults_from, vaults_to: tier.vaults_to, share_pct: tier.share_pct });
  };

  const cancelEdit = () => { setEditingId(null); setEditValues({}); };

  const handleSave = async (id) => {
    await onSave(id, {
      vaults_from: parseInt(editValues.vaults_from),
      vaults_to: parseInt(editValues.vaults_to),
      share_pct: parseFloat(editValues.share_pct),
    });
    setEditingId(null);
  };

  const handleAdd = async () => {
    await onAdd({
      vaults_from: parseInt(newRow.vaults_from),
      vaults_to: parseInt(newRow.vaults_to),
      share_pct: parseFloat(newRow.share_pct),
    });
    setNewRow(emptyRow);
    setAddingNew(false);
  };

  return (
    <div>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
        <thead>
          <tr style={{ background: '#f1f5f9', textAlign: 'left' }}>
            <th style={{ padding: '8px 10px', fontWeight: 600 }}>From</th>
            <th style={{ padding: '8px 10px', fontWeight: 600 }}>To</th>
            <th style={{ padding: '8px 10px', fontWeight: 600 }}>Revenue share %</th>
            <th style={{ padding: '8px 10px', fontWeight: 600 }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {tiers.map(tier => (
            <tr key={tier.id} style={{ borderBottom: '1px solid #e2e8f0' }}>
              {editingId === tier.id ? (
                <>
                  <td style={{ padding: '6px 10px' }}>
                    <input type="number" style={inputStyle} value={editValues.vaults_from}
                      onChange={e => setEditValues(p => ({ ...p, vaults_from: e.target.value }))} />
                  </td>
                  <td style={{ padding: '6px 10px' }}>
                    <input type="number" style={inputStyle} value={editValues.vaults_to}
                      onChange={e => setEditValues(p => ({ ...p, vaults_to: e.target.value }))} />
                  </td>
                  <td style={{ padding: '6px 10px' }}>
                    <input type="number" step="0.01" style={inputStyle} value={editValues.share_pct}
                      onChange={e => setEditValues(p => ({ ...p, share_pct: e.target.value }))} />
                  </td>
                  <td style={{ padding: '6px 10px', display: 'flex', gap: '6px' }}>
                    <button onClick={() => handleSave(tier.id)} disabled={saving} style={btnPrimary}>Save</button>
                    <button onClick={cancelEdit} style={btnSecondary}>Cancel</button>
                  </td>
                </>
              ) : (
                <>
                  <td style={{ padding: '6px 10px' }}>{tier.vaults_from}</td>
                  <td style={{ padding: '6px 10px' }}>{tier.vaults_to}</td>
                  <td style={{ padding: '6px 10px' }}>{tier.share_pct}%</td>
                  <td style={{ padding: '6px 10px', display: 'flex', gap: '6px' }}>
                    <button onClick={() => startEdit(tier)} style={btnSecondary}>Edit</button>
                    <button onClick={() => onDelete(tier.id)} style={btnDanger}>Delete</button>
                  </td>
                </>
              )}
            </tr>
          ))}
          {addingNew && (
            <tr style={{ borderBottom: '1px solid #e2e8f0', background: '#f8fafc' }}>
              <td style={{ padding: '6px 10px' }}>
                <input type="number" style={inputStyle} placeholder="1" value={newRow.vaults_from}
                  onChange={e => setNewRow(p => ({ ...p, vaults_from: e.target.value }))} />
              </td>
              <td style={{ padding: '6px 10px' }}>
                <input type="number" style={inputStyle} placeholder="20" value={newRow.vaults_to}
                  onChange={e => setNewRow(p => ({ ...p, vaults_to: e.target.value }))} />
              </td>
              <td style={{ padding: '6px 10px' }}>
                <input type="number" step="0.01" style={inputStyle} placeholder="10" value={newRow.share_pct}
                  onChange={e => setNewRow(p => ({ ...p, share_pct: e.target.value }))} />
              </td>
              <td style={{ padding: '6px 10px', display: 'flex', gap: '6px' }}>
                <button onClick={handleAdd} disabled={saving || !newRow.vaults_from || !newRow.vaults_to || !newRow.share_pct} style={btnPrimary}>Add</button>
                <button onClick={() => { setAddingNew(false); setNewRow(emptyRow); }} style={btnSecondary}>Cancel</button>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {!addingNew && (
        <button onClick={() => setAddingNew(true)} style={{ ...btnPrimary, marginTop: '12px' }}>+ Add tier</button>
      )}
    </div>
  );
};

const inputStyle = { padding: '4px 8px', border: '1px solid #cbd5e1', borderRadius: '4px', fontSize: '13px', width: '80px' };
const btnPrimary = { padding: '4px 12px', background: '#1e40af', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '12px' };
const btnSecondary = { padding: '4px 12px', background: '#f1f5f9', color: '#334155', border: '1px solid #cbd5e1', borderRadius: '5px', cursor: 'pointer', fontSize: '12px' };
const btnDanger = { padding: '4px 12px', background: '#fee2e2', color: '#dc2626', border: '1px solid #fca5a5', borderRadius: '5px', cursor: 'pointer', fontSize: '12px' };

export default RevShareTierTable;
